import { graphql } from 'react-relay';

export default graphql`
    query headerRootQuery(
        $hasUserId: Boolean!
        $hasTradeUserId: Boolean!
        $previewKey: String = ""
        $userId: String!
        $userIds: [String]!
        $isClient: Boolean!
        $fetchRegionalInfo: Boolean!
        $fetchTradeNav: Boolean!
        $fetchNav: Boolean!
        $zipCode: String!
        $userCountryCode: String = ""
        $hasSessionCountryCode: Boolean!
        $localRecentHistoryItemIds: [String] = []
        $fetchUserRecentHistoryItem: Boolean = false
        $checkoutUserId: String!
        $hasCheckoutUserId: Boolean!
    ) {
        viewer {
            ...Header_viewer
        }
    }
`;

export const initialVariables = {
    hasUserId: false,
    hasTradeUserId: false,
    previewKey: '',
    fetchRegionalInfo: false,
    fetchTradeNav: false,
    fetchNav: false,
    userId: '',
    userIds: [],
    isClient: false,
    zipCode: '',
    userCountryCode: '',
    hasSessionCountryCode: false,
    checkoutUserId: '',
    hasCheckoutUserId: false,
};
